'use strict';

var cx = '006269745027078275837:hvc3rgfbujc';
var gcse = document.createElement('script');
gcse.type = 'text/javascript';
gcse.async = true;
gcse.src = 'https://cse.google.com/cse.js?cx=' + cx;
var s = document.getElementsByTagName('script')[0];
s.parentNode.insertBefore(gcse, s);


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/search/vendor/google-search.js
// module id = 411
// module chunks = 0